export const GET_USERS = 'getUsers';
export const GET_INVITES = 'getInvites';
export const GET_PUBLISHERS = 'getPublishers';
export const GET_BUYERS = 'getBuyers';
export const GET_USER_SETTINGS = 'getUserSettings';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
export const INVITE_USER = 'inviteUser';
export const DELETE_USER = 'deleteUser';
export const DELETE_INVITE = 'deleteInvite';
export const EXPORT_CSV_FILE = 'exportCSVFile';